// ResetPasswordController
app.controller('ResetPasswordController', ['$scope', '$location', 'WdHttpService', 'sessionService', '$timeout',
    function($scope, $location, WdHttpService, sessionService, $timeout) {

        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
        }

        var usernameForNewPassword = sessionService.get("username");

        $scope.submitResetPasswordForm = function() {
            $scope.submitted = true;
            if ($scope.resetPasswordForm.$valid) {
                $scope.showLoading('#resetPasswordButton');

                var data = { password: $scope.password, username: usernameForNewPassword, confirmationCode: $scope.code };
                WdHttpService._reset_password(data)
                    .then(function(response) {
                        if (response.status) {
                            $location.path("/resetpassword-success");
                        }

                    }).catch(error => {
                        $scope.stopLoading('#resetPasswordButton');
                        $scope.errorMessage = true;
                        $scope.errorMsg = error;
                        $timeout(function() {
                            $scope.errorMessage = false;
                        }, 6000);
                    });

            } else {
                return false;
            }
        };
        $scope.inputType = 'password';

        $scope.hideShowPassword = function() {
            if ($scope.inputType == 'password')
                $scope.inputType = 'text';
            else
                $scope.inputType = 'password';
        };

        $scope.sendCodeAgain = function() {

            var data = { username: usernameForNewPassword };
            WdHttpService._send_code_again(data).then(function(response) {
                $scope.successMessage = true;
                $scope.successMsg = response.data.message;
                $timeout(function() {
                    $scope.successMessage = false;
                }, 4000);
            });

        };
    }
]);